import React from "react";
import cs from "classnames";
import Button from "@mui/material/Button";
import "./styles.scss";

const CustomButton = ({
  variant = "contained",
  className,
  children,
  primary,
  secondary,
  primaryDark,
  size,
  ...res
}: any) => {
  return (
    <Button
      variant={variant}
      {...res}
      className={cs(
        { ["text-white defaultBtn"]: variant === "contained" },
        { [className]: className },
        { ["primary"]: primary },
        { ["primaryDark"]: primaryDark },
        { ["secondary"]: secondary },
        { ["small-font"]: size === "small" },
        { ["large-font"]: size === "large" },
        "text-btn"
      )}
    >
      {children}
    </Button>
  );
};
export default CustomButton;
